<template>
  <div class="ba-button">
    <button :class="{ active: active, 'keep-active': keepActive, 'keep-pressed': keepPressed, hasHover: iconHover }"
            :disabled="disabled"
            :style="{ background: background }"
            @click="onClick">
        <i v-if="icon" class="icon default" :class="icon"/>
        <i v-if="iconHover || keepPressed" class="icon hover" :class="iconHover"/>
        <i v-if="iconActive || keepActive" class="icon active" :class="iconActive"/>
        <span v-if="!hideLabel" class="text" :class="{ hasIcon: icon }"><slot/></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    keepActive: {
      type: Boolean,
      default: false
    },
    keepPressed: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      required: false
    },
    iconActive: {
      type: String,
      required: false
    },
    iconHover: {
      type: String,
      required: false
    },
    color: {
      type: String,
      required: false
    },
    colorActive: {
      type: String,
      required: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    background () {
      if (this.active) {
        return this.colorActive || null
      }
      return this.color || null
    }
  },
  methods: {
    onClick (event) {
      if (this.disabled) {
        return
      }
      this.$emit('click', event)
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-button {
  display: inline-block;
  vertical-align: middle;

  button {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    border-radius: 5px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    height: 32px;
    min-width: 32px;
    padding: 8px;
    transition: background-color 0.2s ease,
                box-shadow 0.2s ease,
                opacity 0.2s ease;
    z-index: 2;
    overflow: visible;

    .icon {
      position: absolute;
      top: 8px;
      left: 8px;
      width: 16px;
      height: 16px;
      background-size: cover;
      background-position: center center;
      vertical-align: middle;
      opacity: 1;
      transition: opacity 0.2s ease;

      &.hover {
        opacity: 0;
      }

      &.active {
        opacity: 0;
      }
    }

    .text {
      display: block;
      line-height: 20px;
      vertical-align: middle;
      color: #767676;
      font-size: 12px;
      transition: color 0.2s ease;

      &.hasIcon {
        margin-left: 20px;
      }
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }

    &:not(:disabled) {
      &:hover,
      &.keep-active {
        background-color: #efefef;
        z-index: 3;

        .text {
          color: #444444;
        }
      }
    }

    &.hasHover:not(:disabled):hover {
      .icon.default {
        opacity: 0;
      }

      .icon.hover {
        opacity: 1;
      }
    }

    &.active,
    &:active:not(:disabled),
    &.keep-pressed:not(:disabled) {
      box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.3) !important;
      background-image: linear-gradient(to top, #888888 0%, #666666 100%);
      z-index: 1;

      .icon.default {
        opacity: 0 !important;
      }

      .icon.hover {
        opacity: 0 !important;
      }

      .icon.active {
        opacity: 1 !important;
      }

      .text {
        color: #ffffff !important;
      }
    }
  }
}

</style>
